/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AddSidebar.vue?vue&type=template&id=0eea353d&"
import script from "./AddSidebar.vue?vue&type=script&lang=js&"
export * from "./AddSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports